'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'circle-2';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e0ef';
var svgPathData = ['M16 256a240 240 0 1 0 480 0 240 240 0 1 0 -480 0zm176-86.7c0-4.4 3.6-8 8-8l73.8 0c25.5 0 46.2 20.7 46.2 46.3 0 18-10.4 34.4-26.8 41.9l-52.8 24.5c-19.8 9.2-32.4 29-32.4 50.8l0 11.2 104 0c4.4 0 8 3.6 8 8s-3.6 8-8 8l-112 0c-4.4 0-8-3.6-8-8l0-19.2c0-28 16.3-53.5 41.7-65.3L286.5 235c10.7-5 17.5-15.7 17.5-27.4 0-16.7-13.5-30.3-30.2-30.3l-73.8 0c-4.4 0-8-3.6-8-8z', 'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM200 161.3c-4.4 0-8 3.6-8 8s3.6 8 8 8l73.8 0c16.7 0 30.2 13.5 30.2 30.3 0 11.8-6.8 22.5-17.5 27.4l-52.8 24.5c-25.4 11.8-41.7 37.3-41.7 65.3l0 19.2c0 4.4 3.6 8 8 8l112 0c4.4 0 8-3.6 8-8s-3.6-8-8-8l-104 0 0-11.2c0-21.8 12.6-41.6 32.4-50.8l52.8-24.5c16.3-7.6 26.8-23.9 26.8-41.9 0-25.5-20.7-46.3-46.2-46.3l-73.8 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCircle2 = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;